export default __webpack_public_path__ + "static/media/right.b423a6cf.svg";